/**
*@title 엑스포 영상, 문의처, 엑스포 구성 요소
*@date 2022-02-07
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import {Link} from 'react-router-dom';
import Slider from "react-slick";


import '../../css/main.css';
import '../../css/reset.css';
import '../../css/top-menu.css';

import Footer from '../Footer';
import prepare_img from '../../images/prepare_image.png';

import SymposiumSpeaker2 from './SymposiumSpeaker_day2';

import "../../Components/Slider/slick.css";
import "../../Components/Slider/slick-sympospeaker-theme.css";

import top_img from '../../images_front/sub_page_program.svg'
import top_img_en from '../../images_front/sub_page_program_en.svg'

import { t } from 'i18next';

import "../../Components/Slider/slick.css";
import "../../Components/Slider/slick-sympospeaker-theme.css";


class industrialseminar extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            scrollY: 0,
        }
        this.scrollHandler = this.scrollHandler.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll',this.scrollHandler);
    }
    componentWillUnmount() {
        window.removeEventListener('scroll',this.scrollHandler);
    }

    scrollHandler = () => {
        this.setState({scrollY:window.pageYOffset})
        // console.log(this.state.scrollY);
    }
    
    render () {
        const settings = {
            arrows:true,
            dots: false,
            infinite: true,
            speed: 300,
            // centerMode : true,
            // nextArrow: <ArrowRight />,
            // prevArrow: <ArrowLeft />,
            slidesToShow:1,
            slidesToScroll:1
        };
        return(
            <div>
                <div className='visitor-top-section-wrap'>
                    {
                        t("lang") == "ko"
                        ? <img src={top_img}/>
                        : <img src={top_img_en}/>
                    }
                </div>
                <div className="cnt-section-wrap-6">
                    <div>
                        <ul>
                            {/* <li>
                                <div className="cont-btn-submenu">
                                    <Link to="/about/guide">{t("header_intro_guide")}</Link>
                                </div>
                            </li>
                            <li>
                                <div className="cont-btn-submenu">
                                    <Link to="/about/schedule">{t("header_intro_schedule")}</Link>
                                </div>
                            </li> */}
                            <li>
                                <div className="cont-btn-submenu">
                                    <Link to="/about/seminar">{t("header_intro_seminar")}</Link>
                                </div>
                            </li>
                            <li>
                                <div className="cont-btn-submenu">
                                    <Link to="/about/symposium">{t("header_intro_symposium")}</Link>
                                </div>
                            </li>
                            <li>
                                <div className="cont-btn-submenu-clicked">
                                    <Link to="/about/industrialseminar">{t("header_intro_industrialseminar")}</Link>
                                </div>
                            </li>
                            <li>
                                <div className="cont-btn-submenu">
                                    <Link to="/about/nobel">{t("header_intro_nobel")}</Link>
                                </div>
                            </li>
                            <li>
                                <div className="cont-btn-submenu">
                                    <Link to="/about/event">{t("header_intro_event")}</Link>
                                </div>
                            </li>
                            <li>
                                <div className="cont-btn-submenu">
                                    <Link to="/about/forum">{t("header_intro_forum")}</Link>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                
                <div className='cnt-section-wrap-subpages'>
                    <div className="sect-01-box-01-seminar">
                    <div className="sect-tit">{t("symposium_industry_schedule_title")}</div>
                    <div className="tbl-seminar-schedule">
                    <div style={{display:"inline-block", width:"90%", maxWidth:"1300px"}}>
                    {/* <div className='text-center flex justify-center'> */}
                    <p>{t("symposium_schedule_date2")}</p>
                    <table>
                        <colgroup>
                            {/* <col width="38%"/> */}
                            <col width="15%"/>
                            <col width="15%"/>
                            <col width="50%"/>
                            <col width="20%"/>
                        </colgroup>
                        <tbody>
                        <tr>
                            <td class="left theme" colSpan="3">{t("symposium_schedule_date2_theme")}</td>
                            <td class="right mc" colSpan="1">{t("symposium_schedule_date2_mc1")}</td>
                        </tr>
                        <tr class="purple borderUpBoldPurple">
                            {/* <th rowSpan="8"></th> */}
                            <td>{t("symposium_schedule_col1")}</td>
                            <td>{t("symposium_schedule_col2")}</td>
                            <td>{t("symposium_schedule_col3")}</td>
                            <td>{t("symposium_schedule_col4")}</td>
                        </tr>
                        <tr>
                            <td>{t("symposium_schedule_date2_sem1_hours")}</td>
                            <td>{t("symposium_schedule_date2_sem1_time")}</td>
                            <td>{t("symposium_schedule_date2_sem1_title")}</td>
                            <td>{t("symposium_schedule_date2_sem1_speaker")}</td>
                        </tr>
                        <tr>
                            <td>{t("symposium_schedule_date2_sem2_hours")}</td>
                            <td>{t("symposium_schedule_date2_sem2_time")}</td>
                            <td>{t("symposium_schedule_date2_sem2_title")}</td>
                            <td>{t("symposium_schedule_date2_sem2_speaker")}</td>
                        </tr>
                        <tr>
                            <td>{t("symposium_schedule_date2_sem3_hours")}</td>
                            <td>{t("symposium_schedule_date2_sem3_time")}</td>
                            <td>{t("symposium_schedule_date2_sem3_title")}</td>
                            <td>{t("symposium_schedule_date2_sem3_speaker")}</td>
                        </tr>
                        <tr><td class="theme"></td></tr>
                        <tr>
                            <td class="right mc" colSpan="3"></td>
                            <td class="right mc" colSpan="1">{t("symposium_schedule_date2_mc2")}</td>
                        </tr>
                        <tr class="purple borderUpBoldPurple">
                            {/* <th rowSpan="8"></th> */}
                            <td>{t("symposium_schedule_col1")}</td>
                            <td>{t("symposium_schedule_col2")}</td>
                            <td>{t("symposium_schedule_col3")}</td>
                            <td>{t("symposium_schedule_col4")}</td>
                        </tr>
                        <tr>
                            <td>{t("symposium_schedule_date2_sem5_hours")}</td>
                            <td>{t("symposium_schedule_date2_sem5_time")}</td>
                            <td>{t("symposium_schedule_date2_sem5_title")}</td>
                            <td>{t("symposium_schedule_date2_sem5_speaker")}</td>
                        </tr>
                        <tr>
                            <td>{t("symposium_schedule_date2_sem6_hours")}</td>
                            <td>{t("symposium_schedule_date2_sem6_time")}</td>
                            <td>{t("symposium_schedule_date2_sem6_title")}</td>
                            <td>{t("symposium_schedule_date2_sem6_speaker")}</td>
                        </tr>
                        {/* <tr>
                            <td>{t("symposium_schedule_date2_break_hours")}</td>
                            <td>{t("symposium_schedule_date2_break_time")}</td>
                            <td>{t("symposium_schedule_date2_break_title")}</td>
                            <td>{t("symposium_schedule_date2_break_speaker")}</td>
                        </tr>
                        <tr>
                            <td>{t("symposium_schedule_date2_sem7_hours")}</td>
                            <td>{t("symposium_schedule_date2_sem7_time")}</td>
                            <td>{t("symposium_schedule_date2_sem7_title")}</td>
                            <td>{t("symposium_schedule_date2_sem7_speaker")}</td>
                        </tr>
                        <tr>
                            <td>{t("symposium_schedule_date2_sem8_hours")}</td>
                            <td>{t("symposium_schedule_date2_sem8_time")}</td>
                            <td>{t("symposium_schedule_date2_sem8_title")}</td>
                            <td>{t("symposium_schedule_date2_sem8_speaker")}</td>
                        </tr>
                        <tr>
                            <td>{t("symposium_schedule_date2_sem9_hours")}</td>
                            <td>{t("symposium_schedule_date2_sem9_time")}</td>
                            <td>{t("symposium_schedule_date2_sem9_title")}</td>
                            <td>{t("symposium_schedule_date2_sem9_speaker")}</td>
                        </tr>
                        <tr>
                            <td>{t("symposium_schedule_date2_sem10_hours")}</td>
                            <td>{t("symposium_schedule_date2_sem10_time")}</td>
                            <td>{t("symposium_schedule_date2_sem10_title")}</td>
                            <td>{t("symposium_schedule_date2_sem10_speaker")}</td>
                        </tr> */}
                        </tbody>
                    </table>
                    </div>
                    </div>
                    {/* <div className="sect-01-box-01-seminar" style={{marginBottom:"15%"}}>
                    <div className="sect-03-tit-01 sect-tit">{t("symposium_speaker_title")}</div>
                    <Slider {...settings}>
                    <div className='symposium-speaker-tbl-wrap'>
                        <div class="title">
                            {t("symposium_speaker_day2_title")}
                        </div>
                        <div class="table">
                            <SymposiumSpeaker2/>
                        </div>
                    </div>
                        </Slider>
                    </div> */}
                    </div>

                    {/* </div> */}
                </div>
                {/* <div className='cnt-section-wrap-subpages'>
                    <div className='symposium-speaker-tbl-wrap'>
                    <div className="sect-03-tit-01 sect-tit">{t("symposium_speaker_title")}</div>
                        <div class="title">
                            {t("symposium_speaker_day2_title")}
                        </div>
                        <div class="table">
                            <SymposiumSpeaker2/>
                        </div>
                    </div>
                </div> */}
                
                {/* <div className='cnt-section-wrap-subpages'>
                    
                </div> */}
                <Footer/>
            </div>
        )
    }
}

export default industrialseminar;